import React from "react";
import { NavLink } from "react-router-dom";

// Tabs shared by the customer list and the multi-unit group list, rendered
// under the "Customers" page heading.
const CustomersNav = () => (
  <nav className="customer-nav">
    <ul className="nav">
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/customers"
          activeClassName="active"
          exact={true}
        >
          Customers
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          className="nav-link"
          to="/customers/groups"
          activeClassName="active"
        >
          Groups
        </NavLink>
      </li>
    </ul>
  </nav>
);

export default CustomersNav;
